// src/composables/usePermissions.js
import { ref, onMounted } from 'vue'
import api from '@/services/api'

const permissions = ref({})   // This will store all user permissions

export function usePermissions() {

  const loadPermissions = async () => {
    try {
      const res = await api.get('CurrentPermissions.php')
      permissions.value = res.data || {}
      console.log("✅ Permissions loaded:", permissions.value)
    } catch (err) {
      console.error('Failed to load permissions', err)
      permissions.value = {}
    }
  }

  // Check if user has a specific permission
const hasPermission = (module, action = 'view') => {
  const normalizedModule = module.toLowerCase()

  const normalizedPermissions = Object.fromEntries(
    Object.entries(permissions.value).map(([key, value]) => [
      key.toLowerCase(),
      value
    ])
  )

  return normalizedPermissions[normalizedModule]?.[action] === true
}
  // Specifically for showing/hiding sidebar menu items
  const canAccessModule = (module) => {
    return hasPermission(module, 'view')   
  }

  onMounted(() => {
    loadPermissions()
  })

  return {
    hasPermission,
    canAccessModule,
    loadPermissions
  }
}